webpackJsonp([67657523035490],{

/***/ 521:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _PatternConstruction = __webpack_require__(22);
	
	var _PatternConstruction2 = _interopRequireDefault(_PatternConstruction);
	
	var _Markdown = __webpack_require__(5);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	var _CodeTabs = __webpack_require__(7);
	
	var _CodeTabs2 = _interopRequireDefault(_CodeTabs);
	
	var _CodeTab = __webpack_require__(6);
	
	var _CodeTab2 = _interopRequireDefault(_CodeTab);
	
	var _QuickstartBranch = __webpack_require__(8);
	
	var _QuickstartBranch2 = _interopRequireDefault(_QuickstartBranch);
	
	var _final = __webpack_require__(99);
	
	var _final2 = _interopRequireDefault(_final);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _PatternConstruction2.default,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'Start the Mock API Server'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'In this step we\'ll start the mock API server, so that we can create, update and delete data.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Start the Mock API Server'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Open a second command line interface, and start the mock server using this command:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { type: 'sh', text: '\n      $ npm run server\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Once the API server boots up, you should see output that looks like this:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { type: 'sh', text: '\n      {^_^}/ hi!\n\n      Loading db.json\n      Done\n\n      Resources\n      http://localhost:1337/users\n      http://localhost:1337/tweets\n\n      Home\n      http://localhost:1337\n\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'The output above tells us that the API server is available at ',
	      _react2.default.createElement(
	        'a',
	        { href: 'http://localhost:1337', target: '_blank' },
	        'http://localhost:1337'
	      ),
	      ' and that we can obtain the list of ',
	      _react2.default.createElement(
	        'strong',
	        null,
	        'users'
	      ),
	      ' from ',
	      _react2.default.createElement(
	        'code',
	        null,
	        '/users'
	      ),
	      ' and the list of ',
	      _react2.default.createElement(
	        'strong',
	        null,
	        'tweets'
	      ),
	      ' from ',
	      _react2.default.createElement(
	        'code',
	        null,
	        '/tweets'
	      ),
	      '.'
	    ),
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Next Steps'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Next we\'re going to ',
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '../step-3/' },
	        'familiarize ourselves with the application'
	      ),
	      '.'
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-forms-pattern-setup-step-2-js-bf172510c1ad70f949b7.js